import clsx from 'clsx'
import { useCallback, useEffect, useState, type FunctionComponent, type ReactNode } from 'react'
import SvgChevronDown from '../../svg/icons/ChevronDown'
import { Collapsible } from './Collapsible'
import style from './ToggleTabs.module.sass'

type ToggleTabsProps = {
	item: { title: string; content: ReactNode; contentMobile?: ReactNode }
	onClick: () => void
	isTabOpen: boolean
}

export const ToggleTabs: FunctionComponent<ToggleTabsProps> = ({ item, onClick, isTabOpen }) => {
	const [isCategoryOpen, setCategoryOpen] = useState(false)

	useEffect(() => {
		if (isTabOpen) {
			setCategoryOpen(true)
		}
	}, [isTabOpen])

	const handleClick = useCallback(() => {
		setCategoryOpen(!isCategoryOpen)
		onClick()
	}, [isCategoryOpen, onClick])

	return (
		<>
			<button type="button" className={style.toggleRowButtonWrapper} onClick={handleClick}>
				<div className={style.toggleRowButton}>
					<span className={style.label}>
						<div className={style.title}>{item.title}</div>
						<span className={clsx(isCategoryOpen && style.iconWrapperRotate, style.iconWrapper)}>
							<SvgChevronDown />
						</span>
					</span>
				</div>
			</button>

			<div className={style.content}>
				<Collapsible open={isCategoryOpen}>
					<div id="tab">{item.contentMobile ?? item.content}</div>
				</Collapsible>
			</div>
		</>
	)
}
